import Home from "pages/Home"

function App() {
  return (
    <div className="wrapper">
      <Home />
    </div>
  );
}

export default App
